module.exports = __webpack_public_path__ + "static/img/06.71b00d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/bounty/tutorial/06.svg
// module id = 9uhc
// module chunks = 13